import { type TFunction } from 'i18next';
import { ActionButtonValues } from 'src/modules/Flexflow/types';
import { type useDispatch } from 'react-redux';
import { showModal } from 'src/old/actions';
import { MODAL_TYPES } from 'src/shared/components/Modals';

type BulkActionModalContentKeys = ActionButtonValues.INVITE | ActionButtonValues.NOT_INVITED;

type BulkActionModalContent = {
  btnTextKey: string;
  getDescription: (t: TFunction, selectedContracts: number) => string;
};

type ShowBulkActionConfirmationModalProps = {
  dispatch: ReturnType<typeof useDispatch>;
  t: TFunction;
  selectedContracts: number;
  actionType: ActionButtonValues;
  onConfirm: (actionType: ActionButtonValues) => Promise<void>;
};

const bulkActionModalContent: Record<BulkActionModalContentKeys, BulkActionModalContent> = {
  [ActionButtonValues.INVITE]: {
    btnTextKey: 'invite',
    getDescription: (t, selectedContracts) =>
      t('you are going to invite employees', { ns: 'flexflow', count: selectedContracts })
  },
  [ActionButtonValues.NOT_INVITED]: {
    btnTextKey: 'disable',
    getDescription: (t, selectedContracts) =>
      t('you are going to disable employees', { ns: 'flexflow', count: selectedContracts }) +
      '</br></br>' +
      t('you are going to disable employee explanation', { ns: 'flexflow' })
  }
};

export const showBulkActionConfirmationModal = ({
  dispatch,
  t,
  selectedContracts,
  actionType,
  onConfirm
}: ShowBulkActionConfirmationModalProps) => {
  if (actionType !== ActionButtonValues.INVITE && actionType !== ActionButtonValues.NOT_INVITED) {
    return;
  }

  const content = bulkActionModalContent[actionType];

  showModal(
    {
      title: t('configuration.confirmationDialog.are you sure'),
      btnText: t(content.btnTextKey, { ns: 'flexflow' }),
      description: content.getDescription(t, selectedContracts),
      withoutCloseIcon: true,
      noPadding: true,
      onConfirm: async () => {
        await onConfirm(actionType);
      }
    },
    MODAL_TYPES.PROMPT_CONFIRMATION
  )(dispatch);
};
